import { serializeToLatex } from "@ever-tutor/et-ui";

import { wrapMathRun } from "@/features/tutor/utils/mathRun";

type Node = { type: string; value?: string };
type Doc = { nodes: Node[] };

export const serializeMixedDocument = (doc: Doc | null | undefined): string => {
  const nodes = doc?.nodes ?? [];
  const out: string[] = [];
  let prose = "";

  const flushProse = () => {
    if (prose) out.push(prose);
    prose = "";
  };

  nodes.forEach((node) => {
    if (node.type === "text") {
      prose += node.value ?? "";
      return;
    }

    flushProse();
    out.push(wrapMathRun(serializeToLatex({ nodes: [node] } as never)));
  });

  flushProse();

  return out.join("").trim();
};
